import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, CircularProgress } from '@mui/material';

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

interface IProps {
  color?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
  label: string;
  loading: boolean;
  disabled: boolean;
  icon: React.ReactNode;
  menuItems: Array<{ label: string; icon: React.ReactNode; onClick: React.MouseEventHandler<HTMLLIElement>; loading: boolean, disabled: boolean }>
}

export default function ButtonDropdown(props: IProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [indexClicked, setIndexClicked] = React.useState<number>(0);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{display: 'inline', marginLeft: 1, marginRight: 1}}>
      <Button
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        disabled={props.disabled}
        startIcon={props.loading ? <CircularProgress size={24} /> : (props.icon ? props.icon : <KeyboardArrowDownIcon />)}
        color={props.color ? props.color : "inherit"}
      >
        {props.label || 'Options'}
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {props.menuItems && props.menuItems.map((item, index) => (
          <MenuItem
            key={index}
            onClick={(e) => {item.onClick(e); setIndexClicked(index);}}
            disableRipple
            disabled={item.disabled}
          >
            {(item.loading && index === indexClicked) ? <CircularProgress size={20} sx={{marginRight: 1}} /> : item.icon}
            {item.label}
          </MenuItem>
        ))}
      </StyledMenu>
    </Box>
  );
}